<script setup></script>
<template>
  <div class="flex flex-col w-full bg-white">
    <!-- prettier-ignore -->
    <div class="flex-1 flex-col w-full max-w-[1685px] mx-auto px-4 sm:px-8 lg:px-16 mt-10 mb-10">
      <!-- Заменили жесткий p-20 на адаптивный (p-8 sm:p-12 lg:p-20), убрали лишний grid, сделали flex-col -->
      <!-- Убрали -mt-48, из-за которого блок налезал на верхний экран -->
      <!-- prettier-ignore   -->
      <div class="md:bg-greentop lg:bg-greentop xl:bg-greentop 2xl:bg-greentop p-6 sm:p-12 lg:p-20 flex flex-col 
      justify-center items-start text-center rounded-2xl w-full">
        <div class="w-full mx-auto">
          
          <!-- Применили clamp() для плавного изменения размера заголовка, убрав кучу префиксов -->
          <div class="md:text-white lg:text-white xl:text-white 2xl:text-white font-bold 
          text-[clamp(1.25rem,3vw,2rem)] leading-snug">
            <h2>
              Прояви свои таланты и навыки <br>
              вместе с нами
            </h2>
          </div>
          
          <!-- 1 колонка на смартфонах, 4 колонки начиная с планшетов (md), чтобы карточки не раздувались -->
          <div class="grid grid-cols-1 md:grid-cols-4 gap-4 sm:gap-6 xl:gap-10 mt-10 w-full
          max-w-md md:max-w-none mx-auto">
            
            <div class="text-white bg-orangetop p-2 rounded-2xl flex items-center justify-center aspect-square w-full
            cursor-pointer">
              <!-- <img
                src="../../public/svg/logos_python_white.svg"
                alt="Задний фон"
                class="absolute right-0 bottom-0 h-auto opacity-75 z-0 pointer-events-none"
              > -->
              <div class="relative flex flex-col justify-center w-full">
                
                <p class="font-bold text-start text-sm sm:text-base lg:text-lg pl-6">Python - разработчик</p>
                <p class="text-start text-xs sm:text-sm lg:text-sm mb-4 pl-6">От 10 месяцев</p>
                <div class="flex flex-col items-center">
                  <img src="../../public/svg/emojione_laptop-computer.svg" alt="Ноутбук" class="w-50 h-50 z-10">
                </div>
                <p class="font-bold text-start text-sm sm:text-base lg:text-lg pl-6">5999 Р / мес</p>
                <p class="text-start text-xs sm:text-sm lg:text-sm pl-6">В рассрочку на 36 месяцев</p>
                <div class="absolute inset-0 flex items-center justify-center z-0 opacity-100 pointer-events-none">
                    <img src="../../public/svg/logos_python_white.svg" alt="Задний фон" 
                    class="w-full h-auto max-w-[100%]">
                </div>
              </div>
            </div>
            <div class="text-white bg-violettop p-2 rounded-2xl flex items-center justify-center aspect-square w-full
          cursor-pointer">
              <div class="relative flex flex-col justify-center w-full">
                <p class="font-bold text-start text-sm sm:text-base lg:text-lg pl-6">Аналитик</p>
                <p class="text-start text-xs sm:text-sm lg:text-sm mb-4 pl-6">От 14 месяцев</p>
                <div class="flex flex-col items-center">
                  <img src="../../public/svg/emojione_laptop-computer.svg" alt="Документ" class="w-50 h-50 z-10">
                </div>
                <p class="font-bold text-start text-sm sm:text-base lg:text-lg pl-6">6999 Р / мес</p>
                <p class="text-start text-xs sm:text-sm lg:text-sm pl-6">В рассрочку на 36 месяцев</p>
                <div class="absolute inset-0 flex items-center justify-center z-0 opacity-100 pointer-events-none">
                  <img src="../../public/svg/SQL_icon_bg.svg">
                </div>
              </div>
            </div>
            <div class="text-[#3D4653] bg-greenwhitetop rounded-2xl p-2 flex items-center justify-center 
            aspect-square w-full cursor-pointer">
              <div class="relative flex flex-col justify-center w-full">
                <p class="font-bold text-start text-sm sm:text-base lg:text-lg pl-6">Системный</p>
                <p class="text-start text-xs sm:text-sm lg:text-sm mb-4 pl-6">От 14 месяцев</p>
                <div class="flex flex-col items-center">
                  <img src="../../public/svg/emojione_laptop-computer.svg" alt="Ноутбук" class="w-50 h-50 z-10">
                </div>
                <p class="font-bold text-start text-sm sm:text-base lg:text-lg pl-6">6999 Р / мес</p>
                <p class="text-start text-xs sm:text-sm lg:text-sm pl-6">В рассрочку на 36 месяцев</p>
                <div class="absolute inset-0 flex items-center justify-center z-0 opacity-100 pointer-events-none">
                  <img src="../../public/svg/devicon-plain_putty.svg">
                </div>
              </div>
              <!-- <p class="font-bold text-sm sm:text-base lg:text-lg">Системный администратор</p> -->
            </div>
            <div class="text-white bg-violetwhitetop rounded-2xl p-2 flex items-center justify-center 
            aspect-square w-full cursor-pointer">
              <div class="flex flex-col justify-center w-full">
                <p class="font-bold text-start text-sm sm:text-base lg:text-lg pl-6">Системный</p>
                <p class="text-start text-xs sm:text-sm lg:text-sm mb-4 pl-6">От 14 месяцев</p>
                <div class="flex flex-col items-center">
                  <img src="../../public/svg/emojione_laptop-computer.svg" alt="Ноутбук" class="w-50 h-50">
                </div>
                <p class="font-bold text-start text-sm sm:text-base lg:text-lg pl-6">6999 Р / мес</p>
                <p class="text-start text-xs sm:text-sm lg:text-sm pl-6">В рассрочку на 36 месяцев</p>
              </div>
              <!-- <p class="font-bold text-sm sm:text-base lg:text-lg">UX/UI дизайнер</p> -->
            </div>
          </div>
        </div>
      </div>
      <div class="flex-1 flex flex-col w-full mt-10 lg:mt-20">
        <div class="flex-1 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <!-- Данный блок будет переделан под читаемый вид и прижатый текст к левой части -->
          <!-- <div class="text-black text-start">
            <p class="font-bold text-2xl text-[clamp(1.25rem,3vw,2rem)] mb-4">Помогаем получить высшее <br> 
              образование в IT-онлайн</p>
            <p class="mt-2 text-[clamp(0.75rem,3vw,1rem)] mb-4 text-start">
              Мы совмещаем фундаментальную подготовку ведущих российских вузов с практико-ориентированным подходом 
              в онлайн-магистратурах и программах ДПО.</p>
            <p class="mt-2 text-[clamp(0.75rem,3vw,1rem)]">
              Обучение ведут преподаватели университетов и практикующие 
              специалисты из IT-индустрии.</p>
            <p class="mt-2 text-[clamp(0.75rem,3vw,1rem)]">
              В ходе обучения вы работаете 
              с реальными бизнес-кейсами и по итогам получаете диплом государственного образца.
            </p>
          </div> -->
          <div class="text-black text-start max-w-3xl">
            <h3 class="font-bold text-[clamp(1.5rem,3vw,2.5rem)] leading-tight mb-6">
              Помогаем получить высшее <br class="hidden sm:block">
              образование в IT
            </h3>

            <!-- space-y-6 автоматически добавит отступы между всеми абзацами (тегами <p>) внут. -->
            <div class="space-y-6 text-[clamp(0.9rem,2vw,1.1rem)] text-gray-800
            leading-relaxed font-bold">
              <p>
                Мы совмещаем фундаментальную подготовку ведущих российских 
                вузов с практико-ориентированным подходом в онлайн-магистратурах 
                и программах ДПО.
              </p>

              <!-- Объединили два последних предложения в один абзац, как на скриншоте -->
              <p>
                Обучение ведут преподаватели университетов и практикующие 
                специалисты из IT-индустрии. В ходе обучения вы работаете 
                с реальными бизнес-кейсами и по итогам получаете диплом 
                государственного образца.
              </p>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4 w-full">
            <div class="text-black items-center justify-center flex bg-greytop rounded-2xl
            p-4 text-center min-h-[140px]">
              <img src="../../public/svg/president-academy-ico.svg" alt="Логотип призидентского университета">
              <!-- <p>Помогаем получить высшее <br> 
              образование в IT-онлайн</p> -->
            </div>
            <div class="text-black items-center justify-center flex bg-greytop rounded-2xl
            p-4 text-center min-h-[140px]">
            <img src="../../public/svg/mifi-ico.svg" alt="Логотип призидентского университета">  
            <!-- <p>Помогаем получить высшее <br> 
              образование в IT-онлайн</p> -->
            </div>
            <div class="text-black items-center justify-center flex bg-greytop rounded-2xl
            p-4 text-center min-h-[140px]">
              <img src="../../public/svg/tomsk-state-university-ico.svg" alt="Логотип призидентского университета">
              <!-- <p>Помогаем получить высшее <br> 
              образование в IT-онлайн</p> -->
            </div>
            <div class="text-black items-center justify-center flex bg-greytop rounded-2xl
            p-4 text-center min-h-[140px]">
              <img src="../../public/svg/mfti-ico.svg" alt="Логотип призидентского университета">
              <!-- <p>Помогаем получить высшее <br> 
              образование в IT-онлайн</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
